import { render, staticRenderFns } from "./BilancioCard.vue?vue&type=template&id=228f2e03&scoped=true"
import script from "./BilancioCard.vue?vue&type=script&lang=ts"
export * from "./BilancioCard.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "228f2e03",
  null
  
)

export default component.exports